import { render, staticRenderFns } from "./FrameBuilder.vue?vue&type=template&id=75c63d2d&scoped=true&"
import script from "./FrameBuilder.vue?vue&type=script&lang=ts&"
export * from "./FrameBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./FrameBuilder.vue?vue&type=style&index=0&id=75c63d2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c63d2d",
  null
  
)

export default component.exports